import { render, staticRenderFns } from "./approvebrokertransactions.vue?vue&type=template&id=32b92e12"
import script from "./approvebrokertransactions.vue?vue&type=script&lang=js"
export * from "./approvebrokertransactions.vue?vue&type=script&lang=js"
import style0 from "./approvebrokertransactions.vue?vue&type=style&index=0&id=32b92e12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports